import { Box } from '@mantine/core';
import type React from 'react';

export const Page = ({ children }: { children: React.ReactNode }) => (
    <Box px={{ base: 'sm', sm: 'md', lg: 'lg' }} py="lg" maw={1200} mx="auto">
        {children}
    </Box>
);

export const PageWide = ({ children }: { children: React.ReactNode }) => (
    <Box px={{ base: 'sm', sm: 'md', lg: 'lg' }} py="lg">
        {children}
    </Box>
);
